/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { MatchSummaryTablePlannerFragmentDoc } from './MatchSummaryTable.generated';
export type MatchSummaryPlannerFragment = { name: string, id: string };

export type MatchSummaryMatchStatusFragment = { plannerId: string, inflowSource: string, numberOfMessages: number, createdAt: TimeString, hasTalked: boolean };

export const MatchSummaryPlannerFragmentDoc = gql`
    fragment MatchSummaryPlanner on Planner {
  ...MatchSummaryTablePlanner
  name
}
    ${MatchSummaryTablePlannerFragmentDoc}`;
export const MatchSummaryMatchStatusFragmentDoc = gql`
    fragment MatchSummaryMatchStatus on MatchStatus {
  plannerId
  inflowSource
  numberOfMessages
  createdAt
  hasTalked
}
    `;